export enum BannerKeys {
  SelectAndArchiveFolders = 'select-and-archive-folders',
  DragAndDropFields = 'drag-and-drop-fields',
  FormAvailableInMobile = 'form-available-in-mobile',
  FormTableActions = 'form-table-actions',
  PhotoSizesField = 'photo-sizes-field',
  SsoFeatureAvailable = 'sso-feature-available',
  BulkAddPhotoTags = 'bulk-add-photo-tags',
}
